import { useValidateListOrder } from '../../filter';
import { useProductListOrder } from './useProductListOrder';
import { useSetProductListOrder } from './useSetProductListOrder';

export const useValidateProductListOrder = () => {
  return useValidateListOrder(useProductListOrder, useSetProductListOrder);
};
